export default __webpack_public_path__ + "static/dotastatz-og-98999dd17bb6e9281cf31f13f403e172.png";